import { useContext, useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import axios from "../../../../../../../api/axios";
import CaseSummaryContext from "../../../CaseSummaryV2/context/CaseSummaryContext";
import InlineEditRow from "../../components/InlineEditRow";

export default function CommunicationStatus({ caseObj }) {
  const [userValueLabels, setUserValueLabels] = useState({});
  const [userData, setUserData] = useState("");
  const { caseSummaryTrigger } = useContext(CaseSummaryContext);
  const params = useParams();

  useEffect(() => {
    if (!caseObj) {
      return;
    } else {
      axios
        .get(`/api/users/${caseObj.client.pk}/`, {})
        .then((response) => {
          const data = response.data;
          setUserData(data);
        })
        .catch((err) => {
          return err;
        });
    }
  }, [setUserData, params.id, caseObj, caseSummaryTrigger]);

  useEffect(() => {
    axios
      .get(`/api/field_options/all_fields/user/`, {})
      .then((response) => {
        const data = response.data;
        setUserValueLabels(data);
      })
      .catch((err) => {
        return err;
      });
  }, [setUserValueLabels]);

  return !caseObj ? (
    <h2 className="my-2 text-center text-gray-500 underline">
      Content details not available for this account at this time
    </h2>
  ) : (
    <div className="mb-5 w-full">
      <InlineEditRow
        title="Communication Status"
        type="search-select"
        keyVal="comm_status"
        apiUrl={`users/${caseObj.client.pk}/`}
        postKey={"key"}
        postKeyVal={"key"}
        optionsUrl="field_options/?content_type=user&field_name=comm_status&ordering=order"
        displayNameKey={"label"}
        customLimit={20}
        displayDetail={userData}
        valueLabels={userValueLabels}
        disabled={false}
        nullable={false}
      />
    </div>
  );
}
